'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _createForOfIteratorHelper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var PeerDistanceList = require('../peer-list/peer-distance-list');

var EventEmitter = require('events');

var Path = require('./path');

var WorkerQueue = require('./workerQueue');

var utils = require('../utils');
/**
 * Manages a single run of the query.
 */


var Run = /*#__PURE__*/function (_EventEmitter) {
  _inherits(Run, _EventEmitter);

  var _super = _createSuper(Run);

  /**
   * Creates a Run.
   *
   * @param {Query} query
   */
  function Run(query) {
    var _this;

    _classCallCheck(this, Run);

    _this = _super.call(this);
    _this.query = query;
    _this.running = false;
    _this.workers = []; // The peers that have been queried (including error responses)

    _this.peersSeen = new Set(); // The errors received when querying peers

    _this.errors = []; // The closest K peers that have been queried successfully
    // (this member is initialized when the worker queues start)

    _this.peersQueried = null;
    return _this;
  }
  /**
   * Stop all the workers
   */


  _createClass(Run, [{
    key: "stop",
    value: function stop() {
      if (!this.running) {
        return;
      }

      this.running = false;

      var _iterator = _createForOfIteratorHelper(this.workers),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var worker = _step.value;
          worker.stop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    /**
     * Execute the run with the given initial set of peers.
     *
     * @param {Array<PeerId>} peers
     * @returns {Promise}
     */

  }, {
    key: "execute",
    value: function () {
      var _execute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(peers) {
        var paths, numPaths, i, res, _i, _paths, path;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                paths = []; // array of states per disjoint path
                // Create disjoint paths

                numPaths = Math.min(this.query.dht.disjointPaths, peers.length);

                for (i = 0; i < numPaths; i++) {
                  paths.push(new Path(this, this.query.makePath(i, numPaths)));
                } // Assign peers to paths round-robin style


                peers.forEach(function (peer, i) {
                  paths[i % numPaths].addInitialPeer(peer);
                }); // Execute the query along each disjoint path

                _context.next = 6;
                return this.executePaths(paths);

              case 6:
                res = {
                  // The closest K peers we were able to query successfully
                  finalSet: new Set(this.peersQueried.peers),
                  paths: []
                }; // Collect the results from each completed path

                for (_i = 0, _paths = paths; _i < _paths.length; _i++) {
                  path = _paths[_i];

                  if (path.res && (path.res.pathComplete || path.res.queryComplete)) {
                    path.res.success = true;
                    res.paths.push(path.res);
                  }
                }

                return _context.abrupt("return", res);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function execute(_x) {
        return _execute.apply(this, arguments);
      }

      return execute;
    }()
    /**
     * Execute all paths through the DHT.
     *
     * @param {Array<Path>} paths
     * @returns {Promise<void>}
     */

  }, {
    key: "executePaths",
    value: function () {
      var _executePaths = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(paths) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.running = true;
                this.emit('start');
                _context2.prev = 2;
                _context2.next = 5;
                return Promise.all(paths.map(function (path) {
                  return path.execute();
                }));

              case 5:
                _context2.prev = 5;
                // Ensure all workers are stopped
                this.stop(); // Completed the Run

                this.emit('complete');
                return _context2.finish(5);

              case 9:
                if (!(this.errors.length === this.peersSeen.size)) {
                  _context2.next = 11;
                  break;
                }

                throw this.errors[0];

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2,, 5, 9]]);
      }));

      function executePaths(_x2) {
        return _executePaths.apply(this, arguments);
      }

      return executePaths;
    }()
    /**
     * Initialize the list of queried peers, then start a worker queue for the
     * given path.
     *
     * @param {Path} path
     * @returns {Promise<void>}
     */

  }, {
    key: "workerQueue",
    value: function () {
      var _workerQueue = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(path) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.init();

              case 2:
                _context3.next = 4;
                return this.startWorker(path);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function workerQueue(_x3) {
        return _workerQueue.apply(this, arguments);
      }

      return workerQueue;
    }()
    /**
     * Create and start a worker queue for a particular path.
     *
     * @param {Path} path
     * @returns {Promise<void>}
     */

  }, {
    key: "startWorker",
    value: function () {
      var _startWorker = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(path) {
        var worker;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                worker = new WorkerQueue(this.query.dht, this, path, this.query._log);
                this.workers.push(worker);
                _context4.next = 4;
                return worker.execute();

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function startWorker(_x4) {
        return _startWorker.apply(this, arguments);
      }

      return startWorker;
    }()
    /**
     * Initialize the list of closest peers we've queried - this is shared by all
     * paths in the run.
     *
     * @returns {Promise<void>}
     */

  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!this.peersQueried) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt("return");

              case 2:
                if (!this.peersQueriedPromise) {
                  _context6.next = 6;
                  break;
                }

                _context6.next = 5;
                return this.peersQueriedPromise;

              case 5:
                return _context6.abrupt("return");

              case 6:
                // This promise is temporarily stored so that others may await its completion
                this.peersQueriedPromise = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                  var dhtKey;
                  return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          _context5.next = 2;
                          return utils.convertBuffer(_this2.query.key);

                        case 2:
                          dhtKey = _context5.sent;
                          _this2.peersQueried = new PeerDistanceList(dhtKey, _this2.query.dht.kBucketSize);

                        case 4:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5);
                }))(); // After PeerDistanceList is initialized, clean up

                _context6.next = 9;
                return this.peersQueriedPromise;

              case 9:
                delete this.peersQueriedPromise;

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
    /**
     * If we've queried K peers, and the remaining peers in the given `worker`'s queue
     * are all further from the key than the peers we've already queried, then we should
     * stop querying on that `worker`.
     *
     * @param {WorkerQueue} worker
     * @returns {Promise<Boolean>}
     */

  }, {
    key: "continueQuerying",
    value: function () {
      var _continueQuerying = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(worker) {
        var running, someCloser;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(this.peersQueried.length < this.peersQueried.capacity)) {
                  _context7.next = 2;
                  break;
                }

                return _context7.abrupt("return", true);

              case 2:
                // Get all the peers that are currently being queried.
                // Note that this function gets called right after a peer has been popped
                // off the head of the closest peers queue so it will include that peer.
                running = worker.queue.workersList().map(function (i) {
                  return i.data;
                }); // Check if any of the peers that are currently being queried are closer
                // to the key than the peers we've already queried

                _context7.next = 5;
                return this.peersQueried.anyCloser(running);

              case 5:
                someCloser = _context7.sent;

                if (!someCloser) {
                  _context7.next = 8;
                  break;
                }

                return _context7.abrupt("return", true);

              case 8:
                return _context7.abrupt("return", false);

              case 9:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function continueQuerying(_x5) {
        return _continueQuerying.apply(this, arguments);
      }

      return continueQuerying;
    }()
  }]);

  return Run;
}(EventEmitter);

module.exports = Run;